export default "__VITE_ASSET__CeH4sEmt__"